/**
 * Active filter chips — matches item-list ActiveFiltersBar styling for collection facets.
 */

import { X } from 'lucide-react';
import type { ActiveFilter } from './types';

interface EntityListActiveFiltersProps<T = string> {
  activeFilters: ActiveFilter<T>[];
  onRemoveFilter: (filterId: string) => void;
  onClearAll: () => void;
}

export function EntityListActiveFilters<T = string>({
  activeFilters,
  onRemoveFilter,
  onClearAll,
}: EntityListActiveFiltersProps<T>) {
  if (activeFilters.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 px-4 py-2 bg-[var(--surface)]/50 dark:bg-[var(--surface-raised)] border-b border-[var(--rule)] dark:border-[var(--rule)] flex-shrink-0">
      <span className="text-[10px] font-semibold text-[var(--text-ter)] uppercase tracking-wider shrink-0">
        Filtered by
      </span>
      {activeFilters.map((filter) => (
        <span
          key={filter.id}
          className="inline-flex items-center gap-1 px-2 py-0.5 text-xs bg-[var(--slate-dim)] text-[var(--text-sec)] dark:bg-[var(--slate)]/20"
        >
          <span className="font-semibold">{filter.label}</span>
          <button
            type="button"
            onClick={() => onRemoveFilter(filter.id)}
            className="text-[var(--text-sec)] hover:text-[var(--text-pri)] transition-colors"
            aria-label={`Remove ${filter.label} filter`}
          >
            <X className="h-2.5 w-2.5" />
          </button>
        </span>
      ))}
      <button
        type="button"
        onClick={onClearAll}
        className="text-[11px] font-medium text-[var(--text-ter)] hover:text-[var(--text-ter)] ml-1"
      >
        Clear all
      </button>
    </div>
  );
}
